var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavBarLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 236.044,
    height: 41.65,
    viewBox: "0 0 236.044 41.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M779.693-39.594v-.285c0-.7-.287-1.29-.889-1.29a.962.962,0,0,0-.973,1.056c0,2.363,5.1,1.207,5.1,5.581,0,2.548-1.492,3.687-4.241,3.687-2.582,0-4.023-.888-4.023-3.369v-.419h3.016v.285c0,1.022.419,1.391,1.022,1.391a1.031,1.031,0,0,0,1.006-1.156c0-2.364-4.894-1.191-4.894-5.431,0-2.414,1.29-3.738,3.922-3.738,2.715,0,3.871,1.123,3.871,3.687h-2.915",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M607.4-39.594v-.285c0-.7-.285-1.29-.888-1.29a.961.961,0,0,0-.972,1.056c0,2.363,5.095,1.207,5.095,5.581,0,2.548-1.491,3.687-4.24,3.687-2.581,0-4.023-.888-4.023-3.369v-.419h3.018v.285c0,1.022.419,1.391,1.022,1.391a1.03,1.03,0,0,0,1.006-1.156c0-2.364-4.893-1.191-4.893-5.431,0-2.414,1.29-3.738,3.922-3.738,2.715,0,3.872,1.123,3.872,3.687H607.4",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M612.893-40.4h-2.346v-2.649h7.81V-40.4H616.01v9.319h-3.117V-40.4",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M621.658-40.6h-.033l-.855,5.078h1.743Zm-1.977-2.447H623.6l2.917,11.967H623.2l-.318-2.1H620.4l-.318,2.1h-3.319l2.917-11.967Z",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M627.274-40.4h-2.346v-2.649h7.81V-40.4h-2.346v9.319h-3.117V-40.4",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M633.022-43.047h7.089V-40.5h-3.973v2.045h3.721v2.447h-3.721v2.38h4.124v2.547h-7.24V-43.047",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M644.97-43.047h4.458l1.257,7.09h.034l1.257-7.09h4.458v11.967h-2.917V-40h-.033l-1.659,8.917h-2.247L647.92-40h-.033v8.917H644.97V-43.047",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M657.539-43.047h7.089V-40.5h-3.972v2.045h3.721v2.447h-3.721v2.38h4.123v2.547h-7.24V-43.047",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M668.784-33.325h.62c1.207,0,1.358-.5,1.358-3.738S670.611-40.8,669.4-40.8h-.62Zm-3.117-9.722h4.526c3.6,0,3.788,2.85,3.788,5.984s-.185,5.983-3.788,5.983h-4.526V-43.047Z",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M674.917-31.079h3.118V-43.047h-3.118Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M683.917-39.409c0-1.358-.251-1.76-.855-1.76-.955,0-1.056.871-1.056,4.106s.1,4.106,1.056,4.106c.771,0,.939-.67.939-2.933h3.017V-35c0,3.353-1.961,4.157-3.956,4.157-3.5,0-4.274-1.76-4.274-6.218,0-4.576,1.039-6.218,4.274-6.218,2.816,0,3.872,1.475,3.872,3.788v.754h-3.017v-.67",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M691.826-40.6h-.034l-.854,5.078h1.743Zm-1.977-2.447h3.922l2.917,11.967h-3.319l-.318-2.1H690.57l-.318,2.1h-3.319l2.917-11.967Z",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M696.954-43.047h3.118v9.42h3.838v2.547h-6.956V-43.047",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M761.159-40.6h-.034l-.854,5.078h1.744Zm-1.978-2.447H763.1l2.917,11.967H762.7l-.318-2.1H759.9l-.318,2.1h-3.319l2.917-11.967Z",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M770.945-39.594v-.285c0-.7-.285-1.29-.889-1.29a.961.961,0,0,0-.972,1.056c0,2.363,5.1,1.207,5.1,5.581,0,2.548-1.491,3.687-4.241,3.687-2.581,0-4.023-.888-4.023-3.369v-.419h3.017v.285c0,1.022.42,1.391,1.022,1.391a1.031,1.031,0,0,0,1.006-1.156c0-2.364-4.893-1.191-4.893-5.431,0-2.414,1.29-3.738,3.922-3.738,2.715,0,3.87,1.123,3.87,3.687h-2.915",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M783.664-31.079h3.117V-43.047h-3.117Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M792.546-39.594v-.285c0-.7-.285-1.29-.888-1.29a.961.961,0,0,0-.972,1.056c0,2.363,5.094,1.207,5.094,5.581,0,2.548-1.49,3.687-4.24,3.687-2.582,0-4.024-.888-4.024-3.369v-.419h3.018v.285c0,1.022.419,1.391,1.022,1.391a1.03,1.03,0,0,0,1.005-1.156c0-2.364-4.893-1.191-4.893-5.431,0-2.414,1.29-3.738,3.922-3.738,2.715,0,3.871,1.123,3.871,3.687h-2.916",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M798.21-40.4h-2.346v-2.649h7.81V-40.4h-2.346v9.319H798.21V-40.4",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M807.143-40.6h-.034l-.855,5.078H808Zm-1.977-2.447h3.921L812-31.079h-3.319l-.318-2.1h-2.481l-.318,2.1h-3.319l2.917-11.967Z",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M812.271-43.047h3.485l2.012,7.375h.033v-7.375h2.916v11.967H817.3l-2.079-7.391h-.034v7.391h-2.916V-43.047",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M826.717-39.409c0-1.358-.251-1.76-.855-1.76-.956,0-1.056.871-1.056,4.106s.1,4.106,1.056,4.106c.772,0,.939-.67.939-2.933h3.017V-35c0,3.353-1.96,4.157-3.955,4.157-3.5,0-4.274-1.76-4.274-6.218,0-4.576,1.04-6.218,4.274-6.218,2.816,0,3.872,1.475,3.872,3.788v.754h-3.018v-.67",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M830.689-43.047h7.089V-40.5h-3.973v2.045h3.72v2.447h-3.72v2.38h4.123v2.547h-7.24V-43.047",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M602-26.584v2.666H710.683a20.7,20.7,0,0,1-.5-2.666H602",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M838.044-26.584H751.495a20.565,20.565,0,0,1-.5,2.666h87.053v-2.666",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M716.242-26.9a9.486,9.486,0,0,0,.974-1.225c.156-.221.3-.422.435-.592A3.219,3.219,0,0,1,720-30.036a3.257,3.257,0,0,1,2.464,1.016c.234.231.693.708,1.161,1.2.5.521,1.124,1.169,1.285,1.317a.513.513,0,0,0,.5.162c.036-.013.112-.039.137-.21.139-.954,1.834-11.975,2.026-12.911a2.445,2.445,0,0,1,2.558-1.892,2.34,2.34,0,0,1,2.326,1.988c.089.689.5,5.93,1.025,12.711.167,2.143.327,4.208.427,5.469.1-.571.215-1.182.315-1.723s.189-1.024.235-1.3a4.191,4.191,0,0,1,2.441-3.359,4.106,4.106,0,0,0,.973-.671c.811-.809,1.305-1.378,2.243-2.483a3.193,3.193,0,0,1,2.185-1.158,3.526,3.526,0,0,1,2.548.912c.721.623,1.763,1.6,2.682,2.458.577.538,1.079,1.009,1.357,1.255a3.483,3.483,0,0,0,2.267.677h.343a20.963,20.963,0,0,0,.167-2.592A20.826,20.826,0,0,0,730.836-50a20.825,20.825,0,0,0-20.824,20.824,20.964,20.964,0,0,0,.166,2.592h4.675a2.869,2.869,0,0,0,1.389-.317",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "nb-clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M745.707-26.569c-.857-.8-1.923-1.8-2.6-2.387a.926.926,0,0,0-.6-.271.547.547,0,0,0-.359.225c-.879,1.036-1.465,1.718-2.39,2.643a6.564,6.564,0,0,1-1.56,1.114c-.71.4-.951.53-1.111,1.477-.048.283-.138.773-.243,1.338-.173.935-.384,2.083-.5,2.82a2.512,2.512,0,0,1-2.5,2.2h-.056a2.466,2.466,0,0,1-2.427-2.254c-.034-.3-.218-2.653-.539-6.79-.293-3.79-.67-8.636-.874-11.074-.5,3.107-1.6,10.233-1.765,11.359a2.863,2.863,0,0,1-1.884,2.336,3.153,3.153,0,0,1-3.191-.712c-.207-.191-.669-.668-1.4-1.433-.449-.466-.887-.923-1.111-1.144a.718.718,0,0,0-.436-.252c-.083.005-.237.093-.423.325-.1.13-.214.287-.335.459a11.907,11.907,0,0,1-1.248,1.554,5.034,5.034,0,0,1-3.295,1.119h-4.17A20.833,20.833,0,0,0,730.836-8.35a20.834,20.834,0,0,0,20.156-15.573,5.9,5.9,0,0,1-3.874-1.34c-.29-.256-.812-.745-1.412-1.305",
    fill: "none",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3431",
    "data-name": "Group 3431",
    transform: "translate(-7531.978 1038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M773.665-44.281h10.263v14.436H773.665Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M601.368-44.281h10.263v14.436H601.368Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M609.546-44.047h9.81v13.967h-9.81Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M615.764-44.047h11.755v13.967H615.764Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M623.927-44.047h9.81v13.967h-9.81Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M632.022-44.047h9.24v13.967h-9.24Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M643.97-44.047h13.464v13.967H643.97Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M656.539-44.047h9.24v13.967h-9.24Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M664.667-44.047H674.98v13.967H664.667Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M673.917-44.047h5.117v13.967h-5.117Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M677.788-44.281h10.23v14.436h-10.23Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M685.932-44.047h11.755v13.967H685.932Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M695.954-44.047h8.956v13.967h-8.956Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M755.263-44.047h11.756v13.967H755.263Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M764.916-44.281H775.18v14.436H764.916Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M782.664-44.047h5.117v13.967h-5.117Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M786.516-44.281h10.264v14.436H786.516Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M794.864-44.047h9.81v13.967h-9.81Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M801.249-44.047H813v13.967H801.249Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M811.271-44.047h10.447v13.967H811.271Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M820.588-44.281h10.23v14.436h-10.23Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M829.689-44.047h9.24v13.967h-9.24Z",
    fill: "#fffefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M601-27.584H711.683v4.666H601Z",
    fill: "#f4b827"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M749.991-27.584h89.053v4.666H749.991Z",
    fill: "#f4b827"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M709.012-51h43.65v30.809h-43.65Z",
    fill: "#f4b827"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(6929.978 -988)",
    clipPath: "url(#nb-clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M709.683-38.528h42.31V-7.35h-42.31Z",
    fill: "#f4b827"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavBarLogo);
export default __webpack_public_path__ + "static/media/navBarLogo.cbb131a6.svg";
export { ForwardRef as ReactComponent };